var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 92,
    viewBox: "0 0 98 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00098 66.2142C2.00098 66.2142 4.12448 44.5203 27.0607 31.7506C27.0607 31.7506 54.0177 15.1578 53.1008 0.570312C53.1008 0.570312 65.0332 17.8171 49.877 35.6338C49.877 35.6338 41.3393 46.1056 26.5444 49.0447C26.5444 49.0443 12.1513 50.924 2.00098 66.2142Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.79 56.9904C15.79 56.9904 34.4139 46.6223 57.5495 59.0045C57.5495 59.0045 86.0139 72.6689 97.2199 63.6979C97.2199 63.6979 90.0601 83.5517 67.237 80.6329C67.237 80.6329 54.0305 79.2333 43.3623 68.272C43.3623 68.2724 33.7756 57.0597 15.79 56.9904Z",
    fill: "#B8B8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29688 64.5958C2.29688 64.5958 5.99338 43.1272 29.7924 32.1638C29.7924 32.1638 57.8817 17.6995 58.0288 3.08203C58.0288 3.08203 68.6732 21.2008 52.2632 37.7974C52.2632 37.7974 42.9864 47.58 28.0188 49.3683C28.0188 49.3683 13.5329 50.1315 2.29688 64.5958Z",
    fill: "#DADADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7168 56.4725C16.7168 56.4725 36.0414 47.5724 58.2103 61.7052C58.2103 61.7052 85.6003 77.5272 97.4288 69.4478C97.4288 69.4478 88.8446 88.6921 66.2987 84.0211C66.2987 84.0211 53.2305 81.605 43.3907 69.8505C43.3907 69.8505 34.6459 57.9308 16.7168 56.4725Z",
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2179 75.5523C32.2179 84.634 25.0691 91.996 16.2516 91.996C7.43406 91.996 0.286133 84.634 0.286133 75.5523C0.286133 66.4695 7.43406 59.1074 16.2516 59.1074C25.0691 59.1074 32.2179 66.4695 32.2179 75.5523Z",
    fill: "#B8B8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.df026f6ecf90caa7a1737eccf0ea1a3c.svg";
export { ForwardRef as ReactComponent };